import React, { useState, useEffect, useContext } from "react";
import { Form, Row, Col, Button, Image } from "react-bootstrap";
import { Tabs, Tab } from "react-bootstrap";
import { BASE_URL_API_TRANXT_API , BASE_URL_API } from "../../utils/Constants";
import swal from "sweetalert";
import { GlobalContext } from "../../Context/GlobalState";
import { Nav } from "react-bootstrap";
import OutlineList from "./OutlineLIst";
import BumppyOutlet from "./BumppyOutlet";

const OutLet = () => {
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const [agentId, setAgentId] = useState("");
  const [referId, setReferId] = useState("");
  const [userInfo, setUserInfo] = useState("");
  const [search, setSearch] = useState([]);

  const clearData = async () => {
    setAgentId("");
    setTransactionLoaderState(false);
  };

  // did mount
  useEffect(() => {
    // if (agentId && agentId.length > 4) searchUser();
  }, [agentId]);

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const [name, setName] = useState("");
  const [submittedData, setSubmittedData] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmittedData({ name });
    setAgentId(name);
  };

  const handleClear = () => {
    setName("");

    setSubmittedData(null);
    setAgentId(null);
  };

  return (
    <div className="p-4 bg-light" style={{ fontFamily: "auto" }}>
      <div>
          <div>
            <div className="card m-0 p-0 pt-3">
              <div className="card-body m-0 p-0">
              <div >
                
              <div style={{ overflowX: 'auto', width: '100%' }}
                    defaultActiveKey="profile"
                    className=" tab-header justify-content-start"
                  >
                    <div
                      className={`tab-item ${activeTab === 0 ? "active" : ""}`}
                      onClick={() => handleTabClick(0)}
                    >
                      Bumppy Outlet
                    </div>
                 
                    <div
                      className={`tab-item ${activeTab === 1 ? "active" : ""}`}
                      onClick={() => handleTabClick(1)}
                    >
                      OutLet List
                    </div>
                  </div>
                  <div className="tab-content">
                    {activeTab === 0 && (
                      <div>
                        {" "}
                        <BumppyOutlet/>
                      </div>
                    )}
                    {activeTab === 1 && (
                      <div>
                        <OutlineList/>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
    
      </div>
    </div>
  );
};

export default OutLet;
